import * as React from 'react';
import { Product, ProductDetail, Variant } from '../product';

export const themeStyle = (name: string, theme: any) => {
  let value = '#171717';
  if (theme) {
    value = theme[name];
  }

  return { color: value };
};

export const themeBackground = (name: string, theme: any) => {
  let value = '#171717';
  if (theme) {
    value = theme[name];
  }

  return { backgroundColor: value };
};

export interface Props {
  product: Product;
}

export default function ProductAppPreview({ product }: Props) {
  return (
    <div className={'previewWrapper'}>
      <div
        className={'previewWindow'}
        style={themeStyle('background', product.theme)}
      >
        <div className={'previewCover'} key={JSON.stringify(product)}>
          <div
            className={'previewCoverOverlay'}
            style={themeStyle('background', product.theme)}
          />
          <img
            className={'previewCoverImage'}
            src={product.image_url}
            alt={product.name}
          />
        </div>

        <h1
          className={'ph3 pt3 f4 b previewTitle'}
          style={themeStyle('key', product.theme)}
        >
          {product.name}
        </h1>
        <h2
          className={'ph3 f7 b o-80 ttu'}
          style={themeStyle('body', product.theme)}
        >
          {product.company.name}
        </h2>
        {product.public_url && (
          <p
            className={'pill ba dib pa1 ph3 br-pill ttu b f6 ma0 mh3'}
            style={themeStyle('key', product.theme)}
          >
            WEBSITE
          </p>
        )}
        <p
          className={'previewDescription f6'}
          style={themeStyle('body', product.theme)}
        >
          {product.description_text}
        </p>
        <div className="mh3 mv4">
          <h3
            className="ma0 mb3 b f5"
            style={themeStyle('body', product.theme)}
          >
            Details
          </h3>
          {product.details.map((detail: ProductDetail) => (
            <dl className="f6 lh-title mb3">
              <dt
                className="dib b w-third"
                style={themeStyle('body', product.theme)}
              >
                {detail.name}
              </dt>
              <dd className="dib ml0" style={themeStyle('body', product.theme)}>
                {detail.value}
              </dd>
            </dl>
          ))}
        </div>
        <div className="mh3 mv4">
          <h3
            className="ma0 mb3 b f5"
            style={themeStyle('body', product.theme)}
          >
            Buying Options
          </h3>
          {product.variants.map((item: Variant) => (
            <div
              className="mb3 flex justify-between items-center"
              style={themeStyle('body', product.theme)}
            >
              <div>
                <h4 className="ma0 mb1 f6 lh-title">{item.name}</h4>
                <p className="ma0 mb1 truncate lh-title">
                  {item.description_text}
                </p>
              </div>
              <button
                type="button"
                className="f6 link dim br-pill ph3 pv2 mb2 dib"
                style={{
                  ...themeBackground('key', product.theme),
                  ...themeStyle('background', product.theme),
                }}
              >
                Add to cart
              </button>
            </div>
          ))}
        </div>
        <div className="overflow-x-scroll relative mv4">
          <h3
            className="ma0 mh3 mb3 b f5"
            style={themeStyle('body', product.theme)}
          >
            Images
          </h3>
          {product.images.map((item: string) => (
            <img className="w4 h4 dib br2 shadow-4 ml2 mr3" src={item} alt="" />
          ))}
        </div>
      </div>
    </div>
  );
}
